module.exports = __webpack_public_path__ + "static/media/no-image.b1edc35f.png";